import React, { useEffect, useState } from "react"
import { graphql, useStaticQuery } from "gatsby"
import "../../styles/main.scss"
import * as styles from "./layout.module.scss"
// import 'swiper/swiper.scss';
import { Helmet } from "react-helmet"
import { useLocation } from "@reach/router"
import { useSiteQuery, useLocale, useUrl } from "../../hooks"
import loadable from "@loadable/component"
// import Header from "./Header/Header"
const Header = loadable(() => import("./Header/Header"))
const Footer = loadable(() => import("./Footer/Footer"))

const Layout = ({ children }) => {
    const query = graphql`
    {
      allContentfulEkaterraPageNotice {
        edges {
          node {
            slug
            node_locale
          }
        }
      }
    }
  `
    const url = useUrl()
    let locale = useLocale()
    
    const responce = useStaticQuery(query)
    
    const slug = []
    responce.allContentfulEkaterraPageNotice.edges.map(({ node }) => {
        if (node.node_locale === useLocale()) {
            slug.push({
                slug: node.slug,
                newSlug: `/${url}/${node.slug}`,
                node_locale: node.node_locale
            })
        }
    })
  
    const location = useLocation()
    const [hide, setHide] = useState(false)
    useEffect(() => {
        {
            slug.map(loc => {
                if (loc.newSlug === location.pathname || loc.slug === location.pathname.split("/")[3]) {
                    return setHide(true)
                }
            })
        }
    }, [location])

    switch(locale){
        case "ur-PK":
            locale = "style-rtl"
            break
        case "ar-AE":
            locale = "style-rtl"
            break
        case "pl":
            locale = "font-polish"
            break
        default: 
        locale = null
    }


    return (
        <>
            <Helmet>
                <link rel="canonical" href={`https://ekaterratea.com${location.pathname}`}></link>
                <meta http-equiv='cache-control' content='no-cache' />
                <meta http-equiv='expires' content='0' />
                <meta http-equiv='pragma' content='no-cache' />
                <link
                    rel="stylesheet"
                    href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.css"
                    integrity="sha512-wR4oNhLBHf7smjy0K4oqzdWumd+r5/+6QO/vDda76MW5iug4PT7v86FoEkySIJft3XA0Ae6axhIvHrqwm793Nw=="
                    crossOrigin="anonymous"
                    referrerPolicy="no-referrer"
                />
                <link
                    rel="stylesheet"
                    href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick-theme.css"
                    integrity="sha512-6lLUdeQ5uheMFbWm3CP271l14RsX1xtx+J5x2yeIDkkiBpeVTNhTqijME7GgRKKi6hCqovwCoBTlRBEC20M8Mg=="
                    crossOrigin="anonymous"
                    referrerPolicy="no-referrer"
                />
            </Helmet>
            {!hide && <Header />}
            <main className={`main ${locale} ${hide ? styles.notice : styles.layout}`}>
                <div className="page">{children}</div>
            </main>
            {!hide && <Footer />}
        </>
    )
}

export default Layout
